import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

//internal import
import HolidayService from "../services/HolidayService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useHolidaySubmit = (id) => {

  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

  const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [viewData, setviewData] = useState([]);
  const [holidayId, setHolidayId] = useState("");


  // add and update holiday details
  const onSubmit = async (data) => {

    setPageLoading(true);

    try {
      const response = id ? await HolidayService.UpdateHolidayById(id, data) : await HolidayService.addHoliday(data);
      if (response?.success) {
        notifySuccess(response.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response.message);
      }
    } catch (error) {
      console.error(error);
      notifyError("Something went wrong.");
    } finally {
      setPageLoading(false);
    }
  };

  //  delete holiday by id 
  const handleDeleteHoliday = async (id) => {
    try {
      const response = await HolidayService.deleteHolidayById(id);
      if (response.success) {
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError("Something want wrong !");
      setIsDeleteModal(false);
    }
  }

  useEffect(() => {
    reset();
    if (id) {
      (async () => {
        try {
          const res = await HolidayService.getHolidayById(id);
          const data = res?.data;

          if (res?.success) {
            setviewData(data);
            setValue("holidayName", data.holidayName);
            setValue("holidayDate", dayjs(data.holidayDate).format("YYYY-MM-DD"));
          }
        } catch (error) {
          console.error("Error fetching holiday data:", error);
        }
      })();
    }
  }, [isModal, id]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    handleDeleteHoliday,
    pageLoading,
    isModal,
    setIsModal,
    isViewModal,
    setIsViewModal,
    isDeleteModal,
    setIsDeleteModal,
    viewData,
    holidayId,
    setHolidayId
  }
}

export default useHolidaySubmit;